import React, { useEffect, useState } from 'react';
import { Box, Button, IconButton, Paper, Typography } from '@mui/material';
import Close from '@mui/icons-material/Close';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useVersionCheck } from '../hooks/useVersionCheck';

export const VersionUpdateToast = () => {
  const { latestVersion } = useVersionCheck();
  const [open, setOpen] = useState(false);
  const [dismissedVersion, setDismissedVersion] = useState<string | null>(null);

  useEffect(() => {
    if (latestVersion && latestVersion !== dismissedVersion) {
      setOpen(true);
    }
  }, [latestVersion, dismissedVersion]);

  const handleRefresh = () => {
    window.location.reload();
  };

  const handleClose = () => {
    if (latestVersion) {
      setDismissedVersion(latestVersion);
    }
    setOpen(false);
  };

  if (!open) return null;

  return (
    <Box sx={{ position: 'fixed', bottom: 24, right: 24, zIndex: 1400 }}>
      <Paper
        elevation={6}
        sx={{
          p: 1,
          gap: 1,
          border: '1px solid',
          borderColor: 'elevation.outlined',
          backgroundColor: 'var(--mui-palette-background-paper-elevation-5)',
          boxShadow: '0 1px 18px 0 rgba(0, 0, 0, 0.12), 0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 3px 5px -1px rgba(0, 0, 0, 0.20)',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'flex-start',
          position: 'relative',
          overflow: 'hidden',
          minWidth: 300,
          maxWidth: 500,
        }}
        role="status"
        aria-live="polite"
      >
        <Box p={0.5} display="flex" alignItems="center">
          <InfoOutlinedIcon fontSize="small" color="inherit" />
        </Box>
        <Box sx={{ flex: 1, alignSelf: 'center' }}>
          <Typography variant="body2" fontWeight="bold">
            Update available
          </Typography>
          <Typography variant="body2">A new version of the app is available.</Typography>
        </Box>
        <Button size="small" variant="contained" onClick={handleRefresh} sx={{ alignSelf: 'center', whiteSpace: 'nowrap' }}>
          Refresh
        </Button>
        <IconButton size="small" aria-label="close" onClick={handleClose}>
          <Close fontSize="small" />
        </IconButton>
      </Paper>
    </Box>
  );
};
